// removed by extract-text-webpack-plugin
module.exports = {"aboutMe":"About__aboutMe__3NpMk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/About/About.css
// module id = 293
// module chunks = 0